export default __webpack_public_path__ + "static/media/folder-active.301d6f27.png";